import React from "react";
import { Button, Modal } from "react-bootstrap";

const ConfirmationModal = ({ show, title, body, onCancel, onConfirm, confirmVariant = "danger", confirmText, cancelText, confirmButtonClass, isSubmitting = false }) => (
   <Modal show={show} onHide={onCancel} centered backdrop={isSubmitting ? "static" : true} keyboard={!isSubmitting}>
    <Modal.Header closeButton={!isSubmitting}>
      <Modal.Title className="modal-title-custom">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="modal-body-custom">{body}</Modal.Body>
    <Modal.Footer className="modal-footer-custom">
      <button type="button" className="grey-button" onClick={onCancel} disabled={isSubmitting}>
        {cancelText}
      </button>
      <button type="button" onClick={onConfirm} className={confirmButtonClass || "blue-button"} disabled={isSubmitting}>
        {confirmText}
      </button>
    </Modal.Footer>
  </Modal>
  );

  export default ConfirmationModal;
